import "./src/i18n";
import "./src/styles/global.css";

// An invitation shown in the template preview frame always opens at the top
// (sealed), instead of restoring where the visitor last scrolled it.
export const shouldUpdateScroll = () => window.self === window.top;
